import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import SEO from '../components/shared/SEO';

const NotFoundPage = () => {
  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-gray-50">
      <SEO 
        title="Page non trouvée"
        description="La page que vous recherchez n'existe pas."
        noindex={true}
      />
      
      <div className="text-center px-4">
        {/* 404 Number */}
        <h1 className="text-[150px] md:text-[200px] font-neuropolitical font-bold text-emerald-700 leading-none">
          404
        </h1>
        
        {/* Message */}
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-4 mb-4">
          Oups ! Vous êtes hors piste
        </h2>
        <p className="text-gray-600 max-w-md mx-auto mb-8">
          La page que vous recherchez semble avoir pris un autre chemin. 
          Pas de panique, retrouvez votre route !
        </p>
        
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="bg-emerald-700 hover:bg-emerald-800 text-white gap-2">
              <Home className="w-4 h-4" />
              Retour à l'accueil
            </Button>
          </Link>
          <Button 
            variant="outline" 
            className="gap-2"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4" />
            Page précédente
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
